import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { ActivitiesBarComponent } from "../../../shared/components/activities-bar/activities-bar.component";
import {
  Column,
  CustomTableComponent,
  getReservationStatus,
} from "../../../shared/elements/customTable.component";
import { PagerComponent } from "../../../shared/elements/pager.component";
import { Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useGetUserReservationsHook } from "../hooks/users.hook";
import { useEventsStore } from "../../../shared/stores/events.store";
import { formatDateTime } from "../../../shared/utils/format.util";

export interface UserDetailsResProps {
  id: string;
  fullName: string;
  setSelectedUser: (user: null) => void;
}

const columns: Column[] = [
  { key: "title", label: "Réservation" },
  {
    key: "date",
    label: "Date et heure",
    render: (value) => formatDateTime(value),
  },
  {
    key: "duration",
    label: "Durée",
    render: (value) => value || "—",
  },
  {
    key: "price",
    label: "Prix",
    render: (value) => `${value} €`,
  },
  {
    key: "status",
    label: "Statut",
    render: (value) => {
      const status = getReservationStatus(value);
      return (
        <Typography fontWeight="600" sx={{ color: status.color }}>
          {status.label}
        </Typography>
      );
    },
  },
];

export const UserDetailsResComponent: React.FC<UserDetailsResProps> = ({
  id,
  fullName,
  setSelectedUser,
}) => {
  const { event } = useEventsStore();
  const [page, setPage] = useState(1);
  const { data, isLoading, error } = useGetUserReservationsHook(
    id,
    event,
    page
  );

  useEffect(() => {
    setPage(1);
  }, [event]);

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={1.5}>
        <IconButton onClick={() => setSelectedUser(null)} size="small">
          <ArrowBackIcon
            sx={{
              color: "#B4006E",
            }}
          />
        </IconButton>
        <Typography fontSize="1.15rem" fontWeight="bold" color="#B4006E">
          {fullName}
        </Typography>
      </Box>
      <ActivitiesBarComponent />
      <Box mt={1.5}>
        {isLoading && <Box p={2}>Loading...</Box>}
        {error && <Box p={2}>Error loading reservations</Box>}
        {data && (
          <>
            <CustomTableComponent columns={columns} rows={data.data} />
            <PagerComponent
              page={data.page}
              totalPages={data.totalPages}
              total={data.total}
              onPageChange={setPage}
            />
          </>
        )}
      </Box>
    </Box>
  );
};
